export const mail = {
    '站内信': 'Tin nhắn nội bộ',
    '返回': 'Quay lại',
    '有未读信息': 'Có {amount} tin nhắn chưa đọc',
    '全部标记为已读': 'Đánh dấu tất cả là đã đọc',
    '隐藏已读消息': 'Ẩn tin nhắn đã đọc',
    '展开': 'Mở rộng',
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/vi.js